import React from "react";
import FormRegister from "../components/FormRegister";
import axios from "axios";
import $ from "jquery";
import { navigate } from "gatsby";
import { setAuthTokenState } from "./Auth";

import { saveState } from "../state/utils/localStorage";
import { guestInfo } from "../services/Guest";
import { headerConfig } from "../services/Header";
import { Row, Col, Modal, Button } from "antd";
import { InvitationExpired } from "../components/TWComponents/InvitationExpired";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import { loadState } from "../state/utils/localStorage";

const isAuth0Enabled = process.env.GATSBY_ENABLE_AUTH0 === "true";
const languageSession = loadState("AYANA_LANG_SESSION");

class SignUp extends React.Component {
  loginUrl =
    this.props.langKey === "en" ? "/login" : this.props.langKey + "/login";
  signUpUrl =
    this.props.langKey === "en" ? "/signup" : this.props.langKey + "/signup";

  dateNow = new Date().getTime();

  state = {
    subscribe: true,
    loadings: [],
    terms: false,
    modalTitle: this.props.langData.title_modal_email_exist,
    modalDescription: this.props.langData.description_modal_email_exist,
    visible: false,
    confirmLoading: false,
    invitationData: null,
    tokenInvitation: "",
    showAlert: false,
    alertMessage: "",
  };

  async componentDidMount() {
    if (this.props.location.search !== "") {
      const parsingData = this.props.location.search.split("&");

      if (parsingData.length) {
        const token = parsingData[0].split("?token=");

        if (token.length > 1) {
          const { data, status_code, message } = await this.getUserDataByToken(
            token[1]
          );

          if (status_code === 200) {
            this.setState({
              tokenInvitation: token[1],
              invitationData: {
                ...data,
                subscribe: true,
              },
            });
          } else {
            this.setState({
              showAlert: true,
              alertMessage: message,
            });
          }
        }
      }
    }
  }

  async getUserDataByToken(token) {
    try {
      let self = this;

      const responseData = await axios
        .get(
          `${process.env.GATSBY_API_URL}/api/guest/guest-requests/request-token/` +
            token
        )
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response);
            return error.response.data;
          } else if (error.request) {
            console.log(error.request);
            return error.request.data;
          } else {
            console.log("Error", error.message);
          }
        });

      return {
        data: responseData.data,
        status_code: responseData.status_code,
        message: responseData.message,
      };
    } catch (error) {
      console.log("Error", error);
    }
  }

  showModal() {
    this.setState({
      visible: true,
    });
  }

  handleLoginRedirect() {
    this.setState({
      ModalText: "The modal will be closed after two seconds",
      confirmLoading: true,
    });

    setTimeout(() => {
      this.setState({
        visible: false,
        confirmLoading: false,
      });

      navigate(this.loginUrl);
    }, 2000);
  }

  handleCancel() {
    this.setState({
      visible: false,
    });
  }

  subscribe() {
    this.setState({
      subscribe: !this.state.subscribe,
    });
  }

  setTerms() {
    this.setState({
      terms: !this.state.terms,
    });
  }

  handleUpdate(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  handleChange(value) {
    this.setState({
      nationality: value,
    });
  }

  showLoading() {
    this.setState(({ loadings }) => {
      const newLoadings = [...loadings];
      newLoadings[0] = true;

      return {
        loadings: newLoadings,
      };
    });
  }

  hideLoading() {
    this.setState(({ loadings }) => {
      const newLoadings = [...loadings];
      newLoadings[0] = false;

      return {
        loadings: newLoadings,
      };
    });
  }

  handleErrorMessage(message) {}

  handleSubmit(params) {
    try {
      let self = this;
      self.showLoading();
      let url = "register";
      const bodyFormData = new FormData();
      bodyFormData.append("firstname", params.first_name);
      bodyFormData.append("lastname", params.last_name);
      bodyFormData.append("email", params.email);
      bodyFormData.append("password", params.password);
      // bodyFormData.append('nationality', params.nationality);
      bodyFormData.append("language", self.props.langKey);
      bodyFormData.append("subscribe", params.subscribe == true ? 1 : 0);
      bodyFormData.append("source", "website");

      $(".action_status").removeClass("status_error").text("");

      if (self.state.tokenInvitation !== "") {
        url = "register-invitation";
        bodyFormData.append("token", self.state.tokenInvitation);
      }

      (async () => {
        await axios
          .post(
            `${process.env.GATSBY_API_URL}/api/guest/${url}`,
            bodyFormData,
            headerConfig()
          )
          .then(function (response) {
            self.hideLoading();
            // register normal
            if (response.data.status_code == 200101) {
              saveState("setupTime", self.dateNow);

              saveState("token", response.data.data.token);
              setAuthTokenState(response.data.data.token);
              setTimeout(function () {
                navigate(`${self.props.urlRedirect}?email=${params.email}`);
              }, 500);
            } else if (response.data.status_code == 200100) {
              // register with invitation

              if (response.data.data.status == 1) {
                (async () => {
                  if (await guestInfo(response.data.data.token)) {
                    saveState("setupTime", self.dateNow);
                    setTimeout(function () {
                      navigate(self.props.urlMemberPages);
                    }, 500);
                  } else {
                    navigate(self.props.signUpUrl);
                  }
                })();
              }
            } else if (response.data.status_code == 400316) {
              self.showModal();
            } else {
              $(".action_status")
                .addClass("status_error")
                .text(response.data.message);
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response);
              if (error.response.data.status_code == 400316) {
                self.showModal();
              } else if (error.response.data.status_code == 400149) {
                $(".action_status")
                  .addClass("status_error")
                  .text(error.response.data.message);
              } else if (error.response.data.status_code == 400150) {
                $(".action_status")
                  .addClass("status_error")
                  .text(error.response.data.message);
              }
              self.hideLoading();
            } else if (error.request) {
              console.log(error.request);
              self.hideLoading();
            } else {
              console.log("Error", error.message);
              self.hideLoading();
            }
          });
      })();
    } catch (e) {
      console.log(e);
      this.hideLoading();
    }
  }

  render() {
    if (this.state.showAlert) {
      return (
        <Modal
          title={this.props.langData.title_alert_message}
          visible={true}
          confirmLoading={false}
          centered={true}
          closable={false}
          footer={[
            <Button
              key="submit"
              type="primary"
              onClick={() => navigate(this.loginUrl)}>
              {this.props.langData.btn_label_signin}
            </Button>,
          ]}>
          <Row justify="center">
            <Col md={18} xs={24}>
              <p className="p--sm text--center">{this.state.alertMessage}</p>
            </Col>
          </Row>
        </Modal>
      );
    }

    return isAuth0Enabled ? (
      <InvitationExpired invitationLangData={this.props.invitationLangData} />
    ) : (
      <FormRegister
        handleCancel={(e) => this.handleCancel(e)}
        handleLoginRedirect={(e) => this.handleLoginRedirect(e)}
        setTerms={(e) => this.setTerms(e)}
        state={this.state}
        props={this.props}
        subscribe={(e) => this.subscribe(e)}
        handleChange={(e) => this.handleChange(e)}
        handleUpdate={(e) => this.handleUpdate(e)}
        handleSubmit={(e) => this.handleSubmit(e)}
      />
    );
  }
}

export default isAuth0Enabled
  ? withAuthenticationRequired(SignUp, {
      loginOptions: {
        authorizationParams: {
          ui_locales: languageSession === "zh" ? "zh-CN" : languageSession,
        },
      },
    })
  : SignUp;
